import {AMOUNT} from "app/model/calculator";
import {CalculatorActions} from "actions/calculatorActions";
import {Calculate} from "app/lib/calculate";
import {CalculatorCookieService} from "app/services/calculatorCookieService";
import {first} from 'lodash';

export class CalculatorService {
    constructor(dispatch) {
        this.dispatch = dispatch;
        this.actions = CalculatorActions();
    }

    calculateAmount(state, type) {
        const stateType = type === AMOUNT.OUT ? AMOUNT.OUT : AMOUNT.IN;
        const amount = Calculate(state[stateType].amount, state.exchange);
        const action = type === AMOUNT.OUT ? this.actions.setAmountInAction(amount) : this.actions.setAmountOutAction(amount);

        return this.dispatch(action);
    }

    updateCookies(state) {
        const {countryIn, countryOut, amountIn, amountOut, deliveryMethod, availableDeliveryMethods} = state;

        if (!deliveryMethod) {
            return first(availableDeliveryMethods);
        }

        return CalculatorCookieService.update({
            countryIn,
            countryOut,
            amountIn,
            amountOut,
            deliveryMethod,
        });
    }
}
